module.exports = __webpack_public_path__ + "static/media/Homelessness.256e79c4.svg";